import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "نبذة عنا",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    hr: "hr",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {Aside, FederalMinistryGermanyLogo, LinkBlock, Title} = _components;
  if (!Aside) _missingMdxReference("Aside", true);
  if (!FederalMinistryGermanyLogo) _missingMdxReference("FederalMinistryGermanyLogo", true);
  if (!LinkBlock) _missingMdxReference("LinkBlock", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: "نبذة عنا"
    }), "\n", _jsx(_components.h2, {
      id: "scope",
      children: "SCOPE"
    }), "\n", _jsx(_components.p, {
      children: "يعمل SCOPE على جمع ما ورد من مختلف منتجي البيانات، ولا سيما معهد اليونسكو للإحصاء، بما في ذلك البيانات الإدارية والدراسات الاستقصائية الخاصة بالأسر المعيشية وعمليات تقييم التعلّم وتمويل التعليم، وذلك بغية الكشف عن التقدّم المحرز على صعيد تحقيق رابع أهداف التنمية المستدامة الخاص بالتعليم."
    }), "\n", _jsx(_components.p, {
      children: "يعد هذا الموقع مكملاً للنسخة المطبوعة من التقرير العالمي لرصد التعليم، إذ يتيح للمستخدمين التفاعل مع البيانات لفهم ما حقّقته البلدان والمناطق من إنجازات وما تواجهه من تحديات في سعيها إلى تحقيق الأهداف. وتتيح هذه البيانات التي يمكن تبادلها وتنزيلها للمستخدمين استحداث ملفات الصور وملفات البيانات لمعرفة المزيد، وطباعتها أو استخدامها على الإنترنت أو في عروض."
    }), "\n", _jsx(_components.h2, {
      id: "معلومات-عن-التقرير-العالمي-لرصد-التعليم",
      children: "معلومات عن التقرير العالمي لرصد التعليم"
    }), "\n", _jsx(_components.p, {
      children: "التقرير العالمي لرصد التعليم هو تقرير سنوي يعدّه فريق مستقل وتتولى اليونسكو نشره. ووفقاً لإطار العمل الخاص بالتعليم حتى عام 2030، الغرض منه هو متابعة التقدّم المحرز في تحقيق هدف التنمية المستدامة الخاص بالتعليم وفي تنفيذ الاستراتيجيات التعليمية الوطنية والدولية بغية المساعدة على مساءلة جميع الشركاء المعنيين عن الوفاء بتعهداتهم."
    }), "\n", _jsx(LinkBlock, {
      title: "قُم بزيارة الموقع الإلكتروني",
      url: "https://en.unesco.org/gem-report/",
      variant: "gem"
    }), "\n", _jsx(_components.h2, {
      id: "معلومات-عن-الهدف-4-للتنمية-المستدامة",
      children: "معلومات عن الهدف 4 للتنمية المستدامة"
    }), "\n", _jsx(_components.p, {
      children: "خلال مؤتمر القمة المعني بالتنمية المستدامة الذي عقد في أيلول/سبتمبر 2015 في نيويورك، قامت الدول الأعضاء بتبني خطة التنمية المستدامة لعام 2030. وتتضمّن هذه الخطة 17 هدفاً للتنمية المستدامة، ومنها الهدف 4 المتمثل في \"ضمان التعليم الجيد المنصف والشامل للجميع وتعزيز فرص التعلّم مدى الحياة للجميع\". ويتضمّن الهدف 4 للتنمية المستدامة سبع غايات وثلاث وسائل تنفيذ."
    }), "\n", _jsx(LinkBlock, {
      title: "اطلع على الغايات وأطر المتابعة ذات الصلة",
      url: "https://sustainabledevelopment.un.org/sdg4",
      variant: "sdg4"
    }), "\n", _jsx(FederalMinistryGermanyLogo, {
      lang: "en"
    }), "\n", _jsx(_components.p, {
      children: "نتوجّه بالشكر الخاص إلى الوزارة الاتحادية الألمانية للتعليم والبحوث على شراكتها والمساهمة السخية التي قدّمتها من أجل إنشاء الموقع الإلكتروني الخاص بالتقدّم المحرز في مجال التعليم."
    }), "\n", _jsxs(Aside, {
      children: [_jsx(_components.h2, {
        id: "معلومات-الاتصال",
        children: "معلومات الاتصال"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "البريد الإلكتروني العام"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "mailto:gemreport@unesco.org",
          children: "gemreport@unesco.org"
        })
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "الفريق"
      }), _jsx(_components.p, {
        children: "فريق التقرير العالمي لرصد التعليم، اليونسكو"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "عنواننا\nفريق التقرير العالمي لرصد التعليم، (GEM Report) UNESCO, 7 place de Fontenoy, 75352 Paris 07 SP, France"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
